import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Donations = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Support Pathio</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Support Pathio</li>
          </ul>
        </div>
      </section>

      <section className="ul-section-spacing overflow-hidden">

        <div className="ul-container wow animate__fadeInUp">
          <div
            className="row ul-bs-row row-cols-xl-4 row-cols-md-3 row-cols-2 row-cols-xxs-1"
          >

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/teacher-explaining-the-work-of-solar-panel-to-stud-2025-02-11-18-50-44-utc.jpg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="55"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >People Reached : 2,100</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 3,000</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >Diabetes Education for Uzbek & Central Asian Families</Link
                  >
                  <p className="ul-donation-descr">
                    O'zbek va Markaziy Osiyo oilalari uchun ikki tilli
                    posterlar, TikTok tushuntiruvchilar va klinika resurs
                    kartochkalari. NYC tumanlaridagi tasdiqlangan tibbiy yordam
                    navigatorlariga ulanish.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/presenting-renewable-sources-of-energy-2025-03-17-06-37-43-utc.jpg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="78"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >People Reached : 3,200</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 4,100</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >Hypertension Management Guide - O'zbek/Russian</Link
                  >
                  <p className="ul-donation-descr">
                    Qon bosimi boshqaruvi bo'yicha vizual qo'llanmalar, jamoaviy
                    seminarlar va mahalliy klinikalarga resurs xaritalari.
                    Oilalarga qon bosimi tushunchasini va mahalliy klinikalarni
                    topishga yordam beradi.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/high-school-students-raising-hands-in-classroom-du-2025-03-05-05-09-38-utc.jpg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="62"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >People Reached : 1,850</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 3,000</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >NYC Clinic Directory - Uzbek/Russian/Tajik Languages</Link
                  >
                  <p className="ul-donation-descr">
                    Interaktiv xaritalar va QR-kodli kartochkalar. NYC
                    tumanlaridagi 162+ tasdiqlangan bepul va arzon klinikalarga
                    ulanish, til va xizmatlar bo'yicha filtrlangan. O'zbek, Rus
                    va Tojik tillarida.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="85"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >Students Mentored : 87</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 102</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >Student Mentorship Program - Healthcare Career Pathways</Link
                  >
                  <p className="ul-donation-descr">
                    Tibbiyot sohasidagi aspirantlarga mentorlik, ko'nikmalarni
                    rivojlantirish va real dunyo bo'yicha yo'riqnomalar.
                    Tibbiyot ta'limi, tadqiqot va kontent yaratish tajribasi.
                    Tibbiyot karerasiga yo'llar yaratish.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/teacher-showing-children-solar-panel-2025-01-29-13-28-03-utc.jpg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="45"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >People Reached : 1,200</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 2,700</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >Mental Health Resources - Multilingual Support</Link
                  >
                  <p className="ul-donation-descr">
                    Ruhiy salomatlik bo'yicha vizual tushuntiruvchilar, jamoaviy
                    seminarlar va mahalliy yordam xizmatlariga resurs
                    xaritalari. Oilalarga ruhiy salomatlikni tushunish va
                    mahalliy yordam xizmatlarini topishga yordam beradi. O'zbek,
                    Rus va Tojik tillarida.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/a-girl-writing-with-a-pen-on-a-board-of-equations-2025-04-04-01-07-31-utc.jpeg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="70"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >People Reached : 2,100</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 3,000</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >Asthma Management for NYC Families - Central Asian
                    Communities</Link
                  >
                  <p className="ul-donation-descr">
                    Astma boshqaruvi bo'yicha qo'llanmalar, vizual
                    tushuntiruvchilar va mahalliy klinikalarga resurs
                    xaritalari. NYC oilalariga astma tushunchasini va mahalliy
                    klinikalarni topishga yordam beradi. O'zbek va Rus
                    tillarida.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/young-adult-black-woman-teaching-astronomy-lesson-2025-07-17-17-22-02-utc.jpg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="55"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >Workshops Held : 12</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 22</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >Community Health Literacy Workshops - Brooklyn & Queens</Link
                  >
                  <p className="ul-donation-descr">
                    Ikki tilli jamoaviy seminarlar - diabet, qon bosimi va ruhiy
                    salomatlik bo'yicha. Barcha jamoaviy a'zolar uchun ochiq.
                    Brooklyn va Queens jamoaviy markazlarida o'tkaziladi.
                    O'zbek, Rus va Tojik tillarida.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-donation ul-donation--inner">
                <div className="ul-donation-img">
                  <img
                    src="/assets/new-img/attractive-young-indian-students-study-abroad-at-p-2025-10-15-09-17-39-utc.jpg"
                    alt="donation Image"
                  />
                  <span className="tag">Health</span>
                </div>
                <div className="ul-donation-txt">
                  <div className="ul-donation-progress">
                    <div
                      className="donation-progress-container ul-progress-container"
                    >
                      <div
                        className="donation-progressbar ul-progressbar"
                        data-ul-progress-value="90"
                      >
                        <div
                          className="donation-progress-label ul-progress-label"
                        ></div>
                      </div>
                    </div>
                    <div className="ul-donation-progress-labels">
                      <span className="ul-donation-progress-label"
                        >Resources Created : 248</span
                      >
                      <span className="ul-donation-progress-label"
                        >Target : 275</span
                      >
                    </div>
                  </div>
                  <Link to="/donation-details" className="ul-donation-title"
                    >Visual Health Explainers Library - Science-Based Content</Link
                  >
                  <p className="ul-donation-descr">
                    248+ vizual tushuntiruvchilar - diabet, qon bosimi, astma va
                    ruhiy salomatlik bo'yicha. Ilmiy asoslangan, oson
                    tushuniladigan va vizual jihatdan jozibali kontent. O'zbek,
                    Rus va Tojik tillarida. Ijtimoiy tarmoqlar uchun
                    moslashtirilgan.
                  </p>
                  <Link to="/donation-details" className="ul-donation-btn"
                    >Batafsil <i className="flaticon-up-right-arrow"></i
                  ></Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ul-pagination">
          <ul>
            <li>
              <button type="button" className="pagination-prev" aria-label="Previous"><i className="flaticon-back"></i></button>
            </li>
            <li className="pages" role="navigation" aria-label="Pagination">
              <button type="button" className="active">1</button>
              <button type="button">2</button>
              <button type="button">3</button>
            </li>
            <li>
              <button type="button" className="pagination-next" aria-label="Next"><i className="flaticon-next"></i></button>
            </li>
          </ul>
        </div>
      </section>

    </main>

      <Footer />
    </>
  );
};

export default Donations;
